import {
    PASSWORD_SET_REQUEST,
    PASSWORD_SET_SUCCESS,
    PASSWORD_SET_ERROR,
} from './constants';

const initialState = {
    loading: false,
    result: null,
    error: null,
};

/*
 * REDUCERS
 */

function passwordSetReducer(state = initialState, action) {
    switch (action.type) {
        case PASSWORD_SET_REQUEST:
            return {
                ...state,
                loading: true,
                result: null,
                error: null,
            };
        case PASSWORD_SET_SUCCESS:
            return {
                ...state,
                loading: false,
                result: action.result,
                error: null,
            };
        case PASSWORD_SET_ERROR:
            return {
                ...state,
                loading: false,
                result: null,
                error: action.error,
            };
        default:
            return state;
    }
}

export default passwordSetReducer;
